/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

export const gcpLaunchAllInOneStackURL =
  'https://shell.cloud.google.com/cloudshell/editor?cloudshell_git_repo=https%3A%2F%2Fgithub.com%2Ftrendmicro%2Fcloudone-filestorage-deployment-templates&cloudshell_git_branch=master&cloudshell_workspace=gcp-terraform%2F&cloudshell_tutorial=docs%2Fdeployment_tutorial_all_in_one.md'
export const gcpLaunchScannerStackURL =
  'https://shell.cloud.google.com/cloudshell/editor?cloudshell_git_repo=https%3A%2F%2Fgithub.com%2Ftrendmicro%2Fcloudone-filestorage-deployment-templates&cloudshell_git_branch=master&cloudshell_workspace=gcp-terraform%2F&cloudshell_tutorial=docs%2Fdeployment_tutorial_scanner.md'
export const gcpLaunchStorageStackURL =
  'https://shell.cloud.google.com/cloudshell/editor?cloudshell_git_repo=https%3A%2F%2Fgithub.com%2Ftrendmicro%2Fcloudone-filestorage-deployment-templates&cloudshell_git_branch=master&cloudshell_workspace=gcp-terraform%2F&cloudshell_tutorial=docs%2Fdeployment_tutorial_storage.md'
export const GCP_LAUNCH_DELETE_STACK_CLOUD_SHELL =
  'https://shell.cloud.google.com/cloudshell/editor'
export const GCP_OPEN_CLOUD_SHELL_OIDC =
  'https://shell.cloud.google.com/?hl=en_US&fromcloudshell=true&show=terminal'

export const GCP_DEPLOY_INPUT_KEYS = [
  'gcpAIOTerraformJSON',
  'gcpScannerTerraformJSON',
  'gcpStorageTerraformJSON',
] as Redux.DeployStackInputKeyName[]

export const GCP_OIDC_INPUT_KEYS = [
  'gcpOIDConnectProjectID',
  'gcpOIDConnectTerraformJSON',
] as Redux.OIDConnectInputName[]
